import { useState } from "react";

/** element that has multiple pieces of content that can be expanded */
export function MultiExpando(props: {
  readonly title?: string,    /** text to show before labels */
  readonly labels: string[],  /** text to always show, clicking it shows the corresponding child */
  readonly expanded?: boolean[], /** default: all false */
  readonly children: JSX.Element[], /** content to show when expanded */
}) {
  const [expanded, setExpanded] = useState(props.expanded ?? props.labels.map(_ => false));

  if (props.expanded !== undefined && props.labels.length !== props.expanded?.length) {
    console.log('MultiExpando size mismatch of labels & expanded', JSON.stringify(props.labels), JSON.stringify(props.expanded));
  }

  function changeExpanded(i: number, state: boolean) {
    const newExpanded = expanded.map(b => b);
    newExpanded[i] = state;
    setExpanded(newExpanded);
  }

  return (<span>
    {props.title ? <><b>{props.title}</b>&nbsp;</> : undefined}
    {props.labels.map((label, i) =>
      <span key={i.toString()}>
        <span style={{ whiteSpace: 'nowrap' }}>
          <input type="checkbox" id={label} checked={expanded[i]} onChange={(e) => changeExpanded(i, e.target.checked)} />
          <label htmlFor={label}>{label}</label>
        </span>
        <span> &nbsp;</span>
      </span>
    )}

    {props.children.map((c, i) =>
      expanded[i] ? <span key={props.labels[i]}><br />{c}</span> : undefined
    )}
  </span>);
}
